<template>
  <nav class="navbar sticky-top navbar-expand-lg navbar-dark bg-dark">
    <!-- <a class="navbar-brand" href="#">Navbar</a> -->

    <button
      class="navbar-toggler collapsed"
      type="button"
      data-toggle="collapse"
      data-target="#navbarColor01"
      aria-controls="navbarColor01"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse collapse" id="navbarColor01" style="">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link :to="{ name: 'Building' }" class="nav-link">{{
            $t("list")
          }}</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'People' }" class="nav-link">{{
            $t("people")
          }}</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'Bibliography' }" class="nav-link">{{
            $t("bibliography")
          }}</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'Education' }" class="nav-link">{{
            $t("education")
          }}</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'AboutProject' }" class="nav-link">{{
            $t("aboutProject")
          }}</router-link>
        </li>
      </ul>
    </div>
    <div>
    <!-- <button class="btn btn-secondary mr-2" type="button" @click="deleteOrphanImages()">
      Usuń obrazki
    </button> -->
    <button class="btn btn-secondary mr-2" type="button" @click="register()">
      Nowy użytkownik
    </button>
    <button class="btn btn-secondary" type="button" @click="logOut()">
      Wyloguj się
    </button>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      language: "pl",
      query: "",
      previousQuery: "",
      error: "",
    };
  },
  methods: {
    changeLanguage() {
      this.$localization.changeLang(this.language);
    },
    search() {
      if (!this.query) {
        return;
      }
      if (this.query == this.previousQuery && this.$route.name == "Search") {
        return;
      }

      this.previousQuery = this.query;
      this.$router
        .push({ name: "Search", params: { query: this.query } })
        .catch((err) => {
          this.error = err;
        });
    },
    logOut() {
      if (this.$route.name == "Login") {
        return;
      }
      localStorage.isSignedIn = false;
      localStorage.token = null;
      this.$store.isSignedIn = false;
      this.$router.push({ name: "Login" });
    },
    register() {
      this.$router.push({ name: "Register" });
    },
    deleteOrphanImages(){
      this.$api.deleteOrphanImages().then(console.log("Obrazki usunięte"));
    }
  },
  created() {
    this.language = this.$localization.getLang();
  },
};
</script>
<style>
.nav-item {
  font-size: 20px;
}
.form-control {
  font-size: 20px;
}
.btn {
  font-size: 20px;
}
.language-dropdown {
  max-width: 80px;
}
.search-form {
  display: flex;
}
</style>